export default __webpack_public_path__ + "static/media/logo.a6b0b281.svg";